import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaWhatsapp } from 'react-icons/fa';
import './Navbar.css';

import logoPascolo from '../assets/pascolo-verde.png';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  
  // Contacto wsp
  const numeroWhatsapp = "5492995343092"; 
  const mensajeDefault = "¡Hola! Vengo de la página web de Páscolo y quiero hacer un pedido.";
  const linkWhatsapp = `https://wa.me/${numeroWhatsapp}?text=${encodeURIComponent(mensajeDefault)}`;

  const closeMobileMenu = () => setIsOpen(false);

  return (
    <nav className="navbar">
      {/* 1. Izquierda (Solo Móvil): Menú Hamburguesa */}
      <div className="menu-icon" onClick={() => setIsOpen(!isOpen)}>
        {isOpen ? '✖' : '☰'}
      </div>

      {/* 2. Centro (Móvil) / Izquierda (PC): Logo */}
      <div className="navbar-logo">
        <Link to="/" onClick={closeMobileMenu}>
          <img src={logoPascolo} alt="Pascolo" className="navbar-logo-img" />
        </Link>
      </div>
      
      {/* Links Desplegables */}
      <ul className={isOpen ? "navbar-links active" : "navbar-links"}>
        <li><Link to="/" onClick={closeMobileMenu}>Inicio</Link></li>
        <li><Link to="/productos" onClick={closeMobileMenu}>Productos</Link></li>
        <li><Link to="/quienes-somos" onClick={closeMobileMenu}>Quiénes Somos</Link></li>
        <li><Link to="/como-producimos" onClick={closeMobileMenu}>Cómo Producimos</Link></li>
      </ul>

      {/* 3. Derecha: Botón de WhatsApp fijo en la barra */}
      <div className="navbar-action">
        <a href={linkWhatsapp} target="_blank" rel="noopener noreferrer" className="btn-whatsapp">
            <FaWhatsapp className="whatsapp-icon" />
          <span className="desktop-text">Pedí acá</span>
        </a>
      </div>
    </nav>
  );
};

export default Navbar;